<template>
	<div class="body-container">
		<headerNavigation :showLogin="false"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer" style="height: 115px;"></div>
		</template>
		<div class="site-main-container">
			<div class="comp-login-register-container flow-checkout-container login page-login-register-container"
				style="display: flex;min-height: 1px;">
				<div class="login-register-panel">
					<div class="login-register-content">
						<div id="loginHandler">
							<div class="comp-login-handler-container">
								<div class="header-text-container">
									<h4 class="header-text">{{$t('login.resetpassword')}}</h4>
								</div>
								<div class="comp-login-form-container">
									<div ref="passwordInputRef" class="site-form-group site-input form-group customer-form-group password">
										<label class="site-input-label" > *{{$t('user.newpassword')}}</label>
										<input v-model="password" @focus="bindInputFocus('passwordInputRef')" @blur="handleInputBlur('passwordInputRef',password)" placeholder="" name="password" type="password" minlength="1" maxlength="50" autocomplete="off" class="site-input-group site-form-input form-control">
										
										<a href="javascript:void(0)" class="password-decrypt">
											<span><i class="i-eye password-decrypt-icon"></i></span>
										</a>
										<div class="input-message help-block" id="password"></div>
									</div>
									<div ref="passwordsInputRef" class="site-form-group site-input form-group customer-form-group password">
										<label class="site-input-label" > *{{$t('user.confirmnewpassword')}}</label>
										<input v-model="confirmpassword" @focus="bindInputFocus('passwordsInputRef')" @blur="handleInputBlur('passwordsInputRef',confirmpassword)" placeholder="" name="password" type="password" minlength="1" maxlength="50" autocomplete="off" class="site-input-group site-form-input form-control">
										
									</div>
									<div class="btn-form-group">
									    <div class="btn-container forgot-password-btn-container">
									        <button @click="confirmForget" type="button" class="site-btn-primary forgot-password-submit-btn login-reg-link">
									            <span>{{$t('login.resetpassword')}}</span>
									        </button>
									    </div>
									</div>
									<div class="site-form-group back-to-login-link-container">
									    <a href="javascript:void(0)" @click="toForgetPwd(false)" class="js-end-trap site-secondary-link-italic js-login-link back-button redirect-btn login-link forget-to-login">{{$t('login.backlogin')}}</a>
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loading from '../../components/loading.vue'
	import {resetPassword} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			loading
		},
		data() {
			return {
				isRegister: false,
				isMobile: false,
				isForgetPwd:false,
				isLoading:false,
				email:'',
				password:'',
				lastname:'',
				firstname:'',
				mobile:'',
				confirmpassword:'',
				ckey:''
			};
		},
		mounted() {},
		created() {
			this.isMobile = this.webIsMobile()
			if(this.$route.query.ckey){
				this.ckey = this.$route.query.ckey;
			}
		},
		methods: {
			bindInputFocus(refName){
				var inputRef = this.$refs[refName]
				//inputRef.style = `display:none;`
				inputRef.classList.add('has-value');
			},
			handleInputBlur(refName,val){
				if(!val){
					var inputRef = this.$refs[refName]
					//inputRef.style = `display:block;`
					inputRef.classList.remove('has-value');
				}
			},
			verification() {
				if(!this.password){
					this.$message.warning(this.$t('tips.pleaseinputnewpwd'));
					return false;
				}
				if(!this.confirmpassword){
					this.$message.warning(this.$t('tips.pleaseinputconfirmpwd'));
					return false;
				}
				if(this.password != this.confirmpassword){
					this.$message.warning(this.$t('tips.pwdnotmatch'));
					return false;
				}
				return true;
			},
			confirmForget(){
				if(this.verification()){
					var that = this;
					let params = {
						ckey:this.ckey,
						newpassword:this.password,
						confirmnewpassword:this.confirmpassword
					}
					that.isLoading = true
					resetPassword(params).then(res => {
						that.isLoading = false
						if (res.code == 200) {
							that.$message.success(that.$t('status.success'));
							setTimeout(() => {
							    that.openPage('/login')
							}, 1000);
						}else{
							that.$message.warning(res.msg);
							return false;
						}
						
					})
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/login.css");

	.social-option-login-btn-container {
		margin: 0 auto 40px;
	}

	.social-option-login-btn-container .amazon-social-btn-container,
	.social-option-login-btn-container .google-social-btn-container {
		padding: 5px;
	}

	.social-option-login-btn-container .google-login-btn,
	.social-option-login-btn-container .amazon-login-btn {
		width: 300px;
	}

	.social-option-login-btn-container p {
		text-align: center;
	}

	.social-option-login-btn-container .hidden {
		display: none;
	}

	.customer-alert-warning {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		min-height: 32px;
		padding: 8px 24px;
	}

	.customer-alert-warning .error-icon {
		padding-right: 16px;
	}

	.customer-alert-warning .error-title {
		line-height: 125%;
		margin: 0;
	}

	.customer-alert-warning .error-message {
		line-height: 125%;
		margin: 0;
	}

	.comp-login-handler-container {
		display: grid;
		text-align: center;
	}

	.comp-login-handler-container .customer-form-group {
		position: relative;
		display: grid;
		grid-template-columns: 1fr max-content;
	}

	.comp-login-handler-container .customer-form-group .site-input-label {
		position: absolute;
		top: 0;
		left: 16px;
		margin-bottom: 0;
		padding: 0;
		line-height: 58px;
		opacity: .8;
		transform: scale(1);
		-webkit-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-moz-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-ms-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-o-transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		transition: transform 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		pointer-events: none;
		transform-origin: 0 0;
		z-index: 9;
	}

	.comp-login-handler-container .customer-form-group .site-form-input {
		height: 58px;
		padding: 12px 16px;
		transition: all .2s ease-in-out;
		box-sizing: border-box;
	}

	.comp-login-handler-container .customer-form-group .password-decrypt {
		position: absolute;
		top: 10px;
		left: 83px;
		transform: scale(.9);
		font-size: 13px;
		font-weight: 600;
		color: #757575;
		padding-left: 9px;
		border-left: 1px solid #e1e1e1;
		display: flex;
		align-items: center;
		text-transform: uppercase;
		opacity: 0;
		cursor: text;
		-webkit-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-moz-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-ms-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		-o-transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		transition: opacity 200ms cubic-bezier(0, 0, .2, 1) 0ms;
		text-decoration: none;
		bottom: auto;
	}

	.comp-login-handler-container .customer-form-group .password-decrypt::after {
		content: "show";
		line-height: 14px;
		padding-top: 2px;
	}

	.comp-login-handler-container .customer-form-group .password-decrypt.on::after {
		content: "hide";
	}

	.comp-login-handler-container .customer-form-group .password-decrypt .password-decrypt-icon {
		display: inline-block;
		margin-right: 5px;
		margin-top: 4px;
	}

	.comp-login-handler-container .customer-form-group.active .password-decrypt,
	.comp-login-handler-container .customer-form-group.password-decrypt-active .password-decrypt {
		opacity: 1;
		cursor: pointer;
	}

	.comp-login-handler-container .customer-form-group.active .site-input-label,
	.comp-login-handler-container .customer-form-group.has-value .site-input-label,
	.comp-login-handler-container .customer-form-group.password-decrypt-active .site-input-label {
		line-height: 13px;
		top: 13px;
		z-index: 3;
		transform: scale(.9);
	}

	.comp-login-handler-container .customer-form-group.active .site-form-input,
	.comp-login-handler-container .customer-form-group.has-value .site-form-input,
	.comp-login-handler-container .customer-form-group.password-decrypt-active .site-form-input {
		padding-top: 30px;
		letter-spacing: .25px;
		line-height: 16px;
	}

	.comp-login-handler-container .customer-form-group .site-input-group {
		grid-row: 1;
		grid-column: 1 / span 2;
	}

	.comp-login-handler-container .customer-form-group .input-message {
		grid-row: 2;
		grid-column: 1 / span 2;
	}

	.comp-login-handler-container .header-text-container {
		text-align: left;
	}

	.comp-login-handler-container .comp-login-form-container {
		display: grid;
		gap: 15px;
	}

	.comp-login-handler-container .site-form-group {
		display: grid;
		gap: 5px;
		text-align: left;
	}

	.comp-login-handler-container .site-form-input {
		width: auto;
	}

	.comp-login-handler-container .reset-email {
		text-align: left;
		cursor: pointer;
	}

	.comp-login-handler-container .forgot-password-wrapper {
		grid-row: 3;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.comp-login-handler-container .forgot-password-wrapper a {
		cursor: pointer;
	}

	.comp-login-handler-container .site-btn-primary {
		width: 100%;
		grid-row: span 1;
	}

	.comp-login-handler-container .site-btn-primary:disabled {
		cursor: not-allowed;
	}

	.comp-login-handler-container .link-section {
		display: grid;
		grid-template-columns: 1fr;
		gap: 5px;
		justify-content: center;
		align-items: center;
	}

	.comp-login-handler-container .persistent-login-wrapper {
		text-align: left;
	}

	.comp-login-handler-container .btn-container {
		text-align: center;
	}

	.comp-login-handler-container .terms span {
		display: block;
	}

	.comp-login-handler-container .error-messages-container {
		text-align: left;
	}

	.comp-login-handler-container .link-label {
		margin: 0;
		text-align: left;
	}

	.comp-login-handler-container .header-text {
		margin: 0;
	}

	.comp-login-handler-container .login-create-link {
		margin: 0;
	}
	.back-to-login-link-container {
		align-self: center;
		text-align: center;
	}
	.forget-to-login {
		text-align: center;
	}
</style>
